import React from 'react';
import { useEvents } from '~/shared/hooks/useEvents';
import { usePathname } from 'next/navigation';
import { useFrame } from '~/shared/utils';
import { useUtils } from '~/shared/hooks/useUtils';
import { Brands } from '~/lib/data-contract';
import { Image, Link } from '~/shared/components';
import algoliasearchHelper from 'algoliasearch-helper';
import { BaseHit } from 'instantsearch.js';
import styles from './BrandCategory.module.scss';

export type CardProps = {
    item: Brands;
    className?: string;
    priority?: boolean;
    largePadding?: boolean;
    noPadding?: boolean;
    dataid?: string;
    hitsResults?: algoliasearchHelper.SearchResults<BaseHit>;
};

export const BrandsCategory = ({ item, priority, dataid, hitsResults }: CardProps) => {
    const { target, url } = item.callToAction || {};
    const pathname = usePathname();
    const isOfferPage = pathname?.includes('tilbudsavis');
    const { data } = useFrame();
    const { overlaySearchClickEvent } = useEvents(data);
    const { getHostName } = useUtils();

    const handleClick = (item: Brands) => {
        overlaySearchClickEvent({
            search_term: hitsResults?.query ?? '',
            number_of_results: hitsResults?.nbHits,
            search_url: window.location.href,
            destination_url: `${getHostName()}${item?.callToAction?.url}`,
            type_of_result: 'Other shortcuts',
        });
    };

    return (
        <div
            className={styles.cardContainer}
            data-testid={isOfferPage ? `offer-item-${dataid}` : null}
        >
            <Link onClick={() => handleClick(item)} href={url} noHover target={target}>
                {item.image?.src && (
                    <div className={styles.cardImageWrapper}>
                        <Image
                            priority={priority}
                            {...item.image}
                            alt={item.imageAltText || item.image.name}
                            layout="responsive"
                            sizes="(min-width: 768px) 190px, 110px"
                            objectFit="cover"
                        />
                    </div>
                )}
            </Link>
        </div>
    );
};
